import React, { useState, useEffect } from 'react'
import InfoCards from 'components/InfoCards'
import DriveListIcon from 'components/icons/DriveListIcon'
import { Tabs, Col, Row, Divider, Collapse, Avatar, Spin } from 'antd'
import {
  SectionWrapper,
  TopHeader,
  TopHeading,
  AnchorText,
  CardRow,
  TabDiv,
  FilterCollapse,
  StyleLeft,
  RadioGroup,
  StyledButton,
  StyledCheckbox,
  SpinWrapper,
  StyledTag,
  ExtraPadding,
} from 'modules/Drives/Style/style'
import StyledTabs from 'components/TabsPaneStyles/index'
import SingleListed from 'modules/Drives/Style/singleListed'
import DriveIcon from 'components/icons/DriveIcon'
import FilterIcon from 'components/icons/FilterIcon'
import Flex from 'components/Flex'
import CalendarView from 'modules/Drives/CalendarView'
import CalenderStyled from 'components/CalenderStyled'
import moment from 'moment'

const { TabPane } = Tabs
const { Panel } = Collapse

const Drives = ({
  getDrivesList,
  drivesList,
  driveDateList,
  getStudentData,
  studentDetails,
}) => {
  const [calendarValue, setCalendarValue] = useState(moment().unix())

  const onDateSelected = date => {
    setCalendarValue(date)
  }
  const [cardsData, setCardsData] = useState([])
  const [currentToggle, setCurrentToggle] = useState('left')
  const [calendarView, setCalendarView] = useState('month')
  const [page, setPage] = useState(0)
  const [occurrence, setOccurrence] = useState(null)
  const [date, setDate] = useState('')
  const [driveModeList, setDriveModeList] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (
      (studentDetails?.student?.isExpCandidate ||
        !studentDetails?.student?.isExpCandidate) &&
      occurrence
    )
      getDrivesList({
        occurrence,
        driveModeList,
        date,
        page,
        setLoading,
      })
  }, [occurrence, driveModeList, date, page])

  useEffect(() => {
    getStudentData()
  }, [])
  useEffect(() => {
    if (studentDetails?.student?.isExpCandidate) {
      setOccurrence('REQUESTED')
    } else {
      setOccurrence('UPCOMING')
    }
  }, [studentDetails])
  const onChange = key => {
    setOccurrence(key)
    setPage(0)
  }
  const onChangeFilter = key => {}
  const onPageChange = key => {
    setPage(key - 1)
  }
  const onToggleChange = ({ target: { value } }) => {
    setCurrentToggle(value)
  }
  const onToggleMonthChange = ({ target: { value } }) => {
    setCalendarView(value)
  }

  const onDriveMode = e => {
    let driveListCopy = driveModeList
    if (e.target.checked === true) {
      driveListCopy = [...driveModeList, e.target.name]
      setDriveModeList(driveListCopy)
    }
    if (e.target.checked === false) {
      let index = driveListCopy?.filter(item => item !== e.target.name)

      setDriveModeList(index)
    }
  }

  const clearAll = event => {
    event?.stopPropagation()
    setDriveModeList([])
  }
  useEffect(() => {
    const cardData = [
      {
        key: '1',

        text: 'Total Drives',
        value: drivesList?.totalDrive,
      },
      {
        key: '2',

        text: 'Campus Drive',
        value: drivesList?.campusDrive,
      },
      {
        key: '3',

        text: 'Pool Drive',
        value: drivesList?.poolDrive,
      },
      {
        key: '4',

        text: 'Virtual Drive',
        value: drivesList?.virtualDrive,
      },
    ]
    setCardsData(cardData)
  }, [drivesList])

  const removeFilter = event => {
    event?.stopPropagation()
    setDate('')
  }
  return (
    <SectionWrapper column>
      <TopHeader row spaceBetween alignCenter>
        <TopHeading flexStart>Interview/Drives</TopHeading>
        <RadioGroup defaultValue={currentToggle} onChange={onToggleChange}>
          <StyledButton value="left">
            <Avatar size={24} src={<DriveListIcon className="iconStyle1" />} />
          </StyledButton>
          <StyledButton value="right">
            <Avatar siza={24} src={<DriveIcon className="iconStyle1" />} />
          </StyledButton>
        </RadioGroup>
      </TopHeader>
      {currentToggle == 'left' ? (
        <>
          {!studentDetails?.student?.isExpCandidate && (
            <CardRow spaceBetween>
              {cardsData?.map((card, index) => (
                <InfoCards
                  padding={'10px 25px 20px 25px'}
                  width={'22em'}
                  key={index + 'card'}
                  icon={card?.icon}
                  text={card?.text}
                  value={card?.value}
                />
              ))}
            </CardRow>
          )}

          <Row>
            <Col span={18}>
              <TabDiv>
                {date && (
                  <StyledTag closable onClose={removeFilter}>
                    {moment(date).format('DD/MM/YYYY')}
                  </StyledTag>
                )}
                <StyledTabs activeKey={occurrence} onChange={onChange}>
                  {studentDetails?.student?.isExpCandidate && (
                    <TabPane tab="Requested" key="REQUESTED">
                      {loading ? (
                        <SpinWrapper center>
                          <Spin />
                        </SpinWrapper>
                      ) : (
                        <SingleListed
                          drivesList={drivesList}
                          onPageChange={onPageChange}
                          occurrence={occurrence}
                          studentDetails={studentDetails}
                          page={page}
                        />
                      )}
                    </TabPane>
                  )}
                  {studentDetails?.student?.isExpCandidate && (
                    <TabPane tab="Reschedule" key="RESCHEDULE">
                      {loading ? (
                        <SpinWrapper center>
                          <Spin />
                        </SpinWrapper>
                      ) : (
                        <SingleListed
                          drivesList={drivesList}
                          onPageChange={onPageChange}
                          occurrence={occurrence}
                          studentDetails={studentDetails}
                          page={page}
                        />
                      )}
                    </TabPane>
                  )}
                  <TabPane tab="Upcoming" key="UPCOMING">
                    {loading ? (
                      <SpinWrapper center>
                        <Spin />
                      </SpinWrapper>
                    ) : (
                      <SingleListed
                        drivesList={drivesList}
                        onPageChange={onPageChange}
                        occurrence={occurrence}
                        studentDetails={studentDetails}
                        page={page}
                      />
                    )}
                  </TabPane>
                  <TabPane tab="On-Going" key="ONGOING">
                    {loading ? (
                      <SpinWrapper center>
                        <Spin />
                      </SpinWrapper>
                    ) : (
                      <SingleListed
                        drivesList={drivesList}
                        onPageChange={onPageChange}
                        occurrence={occurrence}
                        studentDetails={studentDetails}
                        page={page}
                      />
                    )}
                  </TabPane>
                  <TabPane tab="Completed" key="COMPLETED">
                    {loading ? (
                      <SpinWrapper center>
                        <Spin />
                      </SpinWrapper>
                    ) : (
                      <SingleListed
                        drivesList={drivesList}
                        onPageChange={onPageChange}
                        occurrence={occurrence}
                        studentDetails={studentDetails}
                        page={page}
                      />
                    )}
                  </TabPane>
                </StyledTabs>
              </TabDiv>
            </Col>
            <Col span={6}>
              <StyleLeft>
                <Flex row spaceBetween>
                  <TopHeading flexStart>
                    <Avatar src={<FilterIcon />} />
                    Filter
                  </TopHeading>
                </Flex>
                <Divider />
                <FilterCollapse
                  bordered={false}
                  expandIconPosition="end"
                  defaultActiveKey={['1', '2', '3', '4']}
                  onChange={onChangeFilter}
                >
                  <Panel
                    header="By Date"
                    key="1"
                    extra={
                      <AnchorText onClick={removeFilter}>Clear</AnchorText>
                    }
                  >
                    <br></br>
                    <CalenderStyled
                      drivesList={driveDateList}
                      calendarValue={calendarValue}
                      setSelected={onDateSelected}
                      setDate={setDate}
                    />
                  </Panel>
                  {!studentDetails?.student?.isExpCandidate && (
                    <Panel
                      header="Drive Mode"
                      key="2"
                      extra={<AnchorText onClick={clearAll}>Clear</AnchorText>}
                    >
                      <StyledCheckbox
                        name="Campus Drive"
                        onChange={onDriveMode}
                        checked={driveModeList?.includes('Campus Drive')}
                      >
                        Campus Drive
                      </StyledCheckbox>
                      <br></br>

                      <StyledCheckbox
                        name="Pool Drive"
                        onChange={onDriveMode}
                        checked={driveModeList.includes('Pool Drive')}
                      >
                        Pool Drive
                      </StyledCheckbox>
                      <br></br>
                      <StyledCheckbox
                        name="Virtual Drive"
                        onChange={onDriveMode}
                        checked={driveModeList.includes('Virtual Drive')}
                      >
                        Virtual Drive
                      </StyledCheckbox>
                    </Panel>
                  )}
                </FilterCollapse>
              </StyleLeft>
            </Col>
          </Row>
        </>
      ) : (
        <Row>
          <Col span={18}>
            <CalendarView
              style={{ padding: '10px' }}
              drivesList={drivesList}
              monthView={calendarView == 'month'}
            />
          </Col>
          <Col span={6}>
            <StyleLeft style={{ paddingLeft: '25px' }}>
              <TopHeader>
                <RadioGroup
                  defaultValue={calendarView}
                  onChange={onToggleMonthChange}
                >
                  <StyledButton value="month">Monthly</StyledButton>
                  <StyledButton value="week">Weekly</StyledButton>
                </RadioGroup>
              </TopHeader>
              {!studentDetails?.student?.isExpCandidate && (
                <ExtraPadding>
                  <TopHeading flexStart>Drive Mode</TopHeading>

                  <StyledCheckbox name="Campus Drive" onChange={onDriveMode}>
                    Campus Drive
                  </StyledCheckbox>
                  <br></br>
                  <StyledCheckbox name="Pool Drive" onChange={onDriveMode}>
                    Pool Drive
                  </StyledCheckbox>
                  <br></br>
                  <StyledCheckbox name="Virtual Drive" onChange={onDriveMode}>
                    Virtual Drive
                  </StyledCheckbox>
                </ExtraPadding>
              )}
            </StyleLeft>
          </Col>
        </Row>
      )}
    </SectionWrapper>
  )
}
export default Drives
